import { IImageAsset } from '../../../modules/images/types'

// A non-square asset is the one the storefronts letterbox rather than crop.
export const applyFilter = (asset: IImageAsset) => asset.width != asset.height
